// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__jzdRK","navItems":"Navbar_navItems__KMiSb","navItemsSelected":"Navbar_navItemsSelected__n3+Cw"};